<template>
    <div>
     <headerNav title="物流列表" />
     <div>
         <!-- <van-cell v-for="item in logsinfo.sublogisticInfos" @click="logisticinfo(item.logisticsNo)" :key="item.logisticsNo" :title="item.platLCompanyName" :value="item.logisticsNo"/> -->
         <div class="vsize" v-for="(item,index) in logsinfo.sublogisticInfos" @click="logisticinfo(item.logisticsNo)" :key="index">
             <div class="v3">
                 <div class="v1">
                 {{item.platLCompanyName}}
                </div>
                <div class="v2">
                    {{item.logisticsNo}}
                    <van-button size="mini" type="info" @click.stop v-clipboard:copy="item.logisticsNo" v-clipboard:success="onCopy" v-clipboard:error="onError">复制</van-button>
                </div>
                <div class="clear"></div>
             </div>
             
         </div>
         
     </div>
    
    </div>
</template>

<script>
export default {
    data() {
        return {
            tid:'',
            QueryLogisticsinfoInputDto:{},
            logsinfo:{}
        }
    },
    created() {
        var option = this.$route.query;
        this.tid = option.tid;
        if (this.tid) {
            this.QueryLogisticsinfoInputDto.tid = this.tid;
            this.getloginfo();
        }
    },
    methods: {
         getloginfo() {
            this.ajax.post('/api/services/app/PhoneTrade/QueryOrderModel', this.QueryLogisticsinfoInputDto).then(x => {
                this.logsinfo = x.result;
                this.logsinfo.sublogisticInfos=this.logsinfo.sublogisticInfos || [];
                if(this.logsinfo.logisticsNo){
                    
                    this.logsinfo.sublogisticInfos.unshift({
                        platLCompanyName:this.logsinfo.platLCompanyName,
                        logisticsNo:this.logsinfo.logisticsNo
                    })
                }
            })
        },
        logisticinfo(item) {
            this.$router.push({
                path: "/logistics",
                query: {
                    tid: this.tid,
                    logisticNo: item
                },
            });
        },
        onCopy(val)
        {
            this.$toast("复制成功");
        },
        onError(e)
        {
            this.$toast("复制失败,原因:"+e);
        }
    },
}
</script>
<style lang="scss" scoped>
.vsize
{
    background-color: white;
    color:#949494;
    padding:5px;
    font-size: 14px;
    
}

.v3{
    margin: 5px;
    border-bottom: 1px solid #f5f5f5
}

.v1,.v2
{
    display: inline-block;
}
.v2{
    float: right;
}
.clear{
    clear:both;
}
</style>